import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "bootstrap";

import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faArrowsAltH,
  faLongArrowAltLeft,
  faLongArrowAltRight,
  faBoxes,
  faBoxOpen,
  faSquare,
  faCheckSquare,
  faTrash,
  faLink,
  faListUl,
  faRandom,
  faUndo,
  faStar,
  faEnvelope,
  faDna,
  faSeedling,
  faPlus,
  faMinus,
  faInfo,
  faHandPointer,
  faIdBadge,
  faBlog,
  faProjectDiagram,
  faEdit,
  faSearch,
  faShoppingCart,
  faAddressBook,
  faQuestion,
  faQuestionCircle,
  faSignOutAlt
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faArrowsAltH,
  faLongArrowAltLeft,
  faLongArrowAltRight,
  faBoxes,
  faBoxOpen,
  faSquare,
  faCheckSquare,
  faTrash,
  faLink,
  faListUl,
  faRandom,
  faUndo,
  faStar,
  faPlus,
  faMinus,
  faEnvelope,
  faDna,
  faSeedling,
  faInfo,
  faHandPointer,
  faIdBadge,
  faBlog,
  faProjectDiagram,
  faEdit,
  faSearch,
  faShoppingCart,
  faAddressBook,
  faQuestion,
  faQuestionCircle,
  faSignOutAlt
);

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
